import {
  Avatar,
  Box,
  Button,
  Grid,
  IconButton,
  LinearProgress,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import Preloader from "./Preloader/Preloader";
import ImageIcon from "@mui/icons-material/Image";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useEffect, useRef, useState } from "react";
import {
  // useGetMealMeMenuDownloadMutation,
  useLazyGetMealMeStoreQuery,
} from "api";
import {
  CustomAnimatedText,
  StyledFooterBox,
  StyledViewWebsiteButton,
} from "./styles";
import { useDispatch } from "react-redux";
import { setError } from "features/error";
import TypingEffect from "./TypingEffect";
import { useLocation, useNavigate } from "react-router-dom";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useMatchMobile } from "hooks/useMatchMobile";
import LanguageIcon from "@mui/icons-material/Language";

const init = [
  {
    link: "https://stage-food.orders.co/slashpizza",
    name: "slashpizza",
  },
  {
    link: "https://stage-food.orders.co/slashpizza2",
    name: "slashpizza2",
  },
];

function ProgressBar({
  texts = [
    "Gathering Information",
    "Downloading Menus",
    // "Deploying Information and Choosing Design",
    "Attaching Menu",
    "Decorating the Preview",
    "Making final touches…",
  ],
  step = 360,
  restaurantLink,
}) {
  const dispatch = useDispatch();
  const { isMatchMobile } = useMatchMobile();
  const [timer, setTimer] = useState(0);
  const [progress, setProgress] = useState(0);
  const [displayedText, setDisplayedText] = useState("...");

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        // Update text based on progress within the setState callback
        if (prev >= 0 && prev < 10 && displayedText !== texts[0]) {
          setDisplayedText(texts[0]);
        } else if (prev >= 10 && prev < 20 && displayedText !== texts[1]) {
          setDisplayedText(texts[1]);
        } else if (prev >= 20 && prev < 30 && displayedText !== texts[2]) {
          setDisplayedText(texts[2]);
        } else if (prev >= 30 && prev < 40 && displayedText !== texts[3]) {
          setDisplayedText(texts[3]);
        } else if (prev >= 40 && displayedText !== texts[4]) {
          // setDisplayedText(texts[4]);
        } else if (prev >= 40 && displayedText !== texts[4]) {
          setDisplayedText(texts[4]);
        }
        return prev + 1;
      });
    }, step);

    if (restaurantLink) {
      setProgress(100);
    }

    if (progress >= 100) {
      setProgress(100);
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [progress, texts, displayedText, step, restaurantLink]);

  useEffect(() => {
    if (timer >= 60) {
      debugger;
      dispatch(
        setError({
          isTimeout: false,
          isServer: false,
          errorMessage: "Oops! Something went wrong, Please try again",
        })
      );
    }
  }, [timer]);

  useEffect(() => {
    // Start a timer when the component mounts
    const intervalId = setInterval(() => {
      setTimer((prevTimer) => prevTimer + 1);
    }, 1000);

    if (restaurantLink) {
      clearInterval(intervalId);
    }
    if (timer >= 60) {
      clearInterval(intervalId);
    }

    // Clean up the timer when the component unmounts
    return () => {
      clearInterval(intervalId);
    };
  }, [restaurantLink]);

  const formattedTime = new Date(timer * 1000).toISOString().substr(14, 5);

  return (
    <Box>
      <CustomAnimatedText>{formattedTime}</CustomAnimatedText>
      <Box sx={{ background: "#d3cfcf" }}>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{ height: "20px" }}
        />
      </Box>
      {!restaurantLink && (
        <Typography sx={{ fontSize: "20px", mt: 1 }}>
          {displayedText}
        </Typography>
      )}
    </Box>
  );
}

const Success = () => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isMatchMobile } = useMatchMobile();
  const [getMealMeStore] = useLazyGetMealMeStoreQuery();
  const id = location.state?.id;
  const [regenerated, setRegenerated] = useState(false);
  const [loading, setLoading] = useState(false);

  const [restaurantLink, setRestaurantLink] = useState([]);
  const intervalIdRef = useRef(null);

  const makeAPICall = async () => {
    try {
      const response = await getMealMeStore(id).unwrap();
      if (response?.error) {
        clearInterval(intervalIdRef.current);
        dispatch(
          setError({
            isTimeout: true,
            errorMessage: "Oops! Something went wrong, Please try again",
          })
        );
      }
      if (response?.restaurantPage) {
        setRestaurantLink(response.restaurantPage);
        localStorage.removeItem("formData");
        // Clear the interval when the response is successful
        clearInterval(intervalIdRef.current);
      }
    } catch (error) {
      console.error("Error making API call:", error);
    }
  };

  useEffect(() => {
    if (id) {
      // Set up interval to make API call every 5 seconds
      intervalIdRef.current = setInterval(makeAPICall, 5000);
      localStorage.removeItem("formData");
    }

    return () => {
      clearInterval(intervalIdRef.current);
    };
  }, [id]);

  const goToLink = (url) => {
    // const url = restaurantLink; // Replace with the URL you want to open
    window.open(url, "_blank");
  };

  const handleStartOver = () => {
    localStorage.removeItem("formData");
    navigate("/");
  };

  const linkData =
    regenerated && restaurantLink.length
      ? restaurantLink
      : restaurantLink.length
      ? [restaurantLink[0]]
      : [];

  const handleRegenerate = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setRegenerated(true);
    }, 2000);
  };

  return (
    // <Grid container justifyContent="center">
    //   <Grid item xs={12} md={12} lg={12} sm={12}>
    <Box>
      {loading && <Preloader overlay />}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto",
          position: "relative",
          p: 2,
          boxSizing: "border-box",
          width: "100%",
        }}
      >
        <Typography variant="h5" sx={{ my: 2 }}>
          {process.env.REACT_APP_SUCCESS_TEXT}
          {/* Your website will be ready in 1 minute… */}
          {/* {restaurantLink.length
          ? "Here is your new website link:"
          : " Your website will be ready in 1 minute…"} */}
        </Typography>
        <Box sx={{ width: "100%", my: 1 }}>
          <ProgressBar restaurantLink={restaurantLink.length} />
        </Box>

        {linkData.length ? (
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              // alignItems: "center",
              flexDirection: "column",
              mt: 8,
              p: 2,
              gap: 2,
            }}
          >
            <Typography variant="h5" sx={{ my: 2, mb: 3 }}>
              Your Website is Ready !
            </Typography>
            <List
              sx={{
                width: "100%",
              }}
              disablePadding
            >
              {linkData.map((item, index) => {
                return (
                  <StyledViewWebsiteButton
                    key={item._id}
                    onClick={() => goToLink(item)}
                    variant="contained"
                    sx={{ width: "100%", mb: 2 }}
                  >
                    <ListItem sx={{ px: 0 }}>
                      <LanguageIcon />
                      <ListItemText
                        sx={{ textAlign: "center" }}
                        primary={`View Your Menu (Version ${index + 1})`}
                      />

                      {/* <OpenInNewIcon color={"white"} /> */}
                    </ListItem>
                  </StyledViewWebsiteButton>
                );
              })}
            </List>
            {restaurantLink.length > 1 && (
              <StyledViewWebsiteButton
                sx={{ color: "black", width: "100%" }}
                variant="outlined"
                onClick={handleRegenerate}
                disabled={linkData.length === 2}
              >
                Regenerate
              </StyledViewWebsiteButton>
            )}
            {/* <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: 3,
            }}
          >
            <Link
              href={restaurantLink}
              sx={{
                fontSize: "16px",
                color: "black",
                textDecorationColor: "black",
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {restaurantLink}
            </Link>

            <StyledViewWebsiteButton variant="contained" onClick={goToLink}>
              View Website
            </StyledViewWebsiteButton>
          </Box> */}
          </Box>
        ) : (
          <Box sx={{ mt: 2 }}>
            <Preloader />
          </Box>
        )}
        {/* {restaurantLink.length ? (
        <StyledViewWebsiteButton
          variant="outlined"
          onClick={handleStartOver}
          sx={{ color: "black", width: "100%" }}
          startIcon={<RestartAltIcon />}
        >
          Start Over
        </StyledViewWebsiteButton>
      ) : null} */}
        <StyledFooterBox sx={{ boxShadow: 4 }}>
          {restaurantLink.length ? (
            <Grid container m-0 p-0>
              <Grid item lg={6} md={12} xs={12} sm={12} m-0 p-0></Grid>
              <Grid item lg={6} md={12} xs={12} sm={12} m-0 p-0>
                <Button
                  variant="contained"
                  onClick={handleStartOver}
                  startIcon={<RestartAltIcon />}
                >
                  Start Over
                </Button>
              </Grid>
            </Grid>
          ) : null}
        </StyledFooterBox>
      </Box>
    </Box>
    //   </Grid>
    // </Grid>
  );
};

export default Success;
